import React from 'react';

const Footer = () => {
  return (
    <div>
      <h2>This is Footer</h2>
    </div>
  );
};

export default Footer;